import { render, staticRenderFns } from "./ViewGroupCoverageTable.vue?vue&type=template&id=5a3cae90&"
import script from "./ViewGroupCoverageTable.vue?vue&type=script&lang=js&"
export * from "./ViewGroupCoverageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports